import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PackVerification.frontend.types'

@Injectable({ providedIn: 'root' })
export class PackVerification_verify_content_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { shippingContainerId: number, inputScan?: { materialCode?: string, serialNumberCode?: string }, inputManual?: { lotId?: number, packagingId?: number, packagedAmount?: number, licenseplateId?: number }, startPackVerificationTaskId: number, canSubstituteSerials?: boolean }): Promise<{ reasons?: string[], isVerified?: boolean, materialId?: number, serialNumberId?: number, lotId?: number, packagingId?: number, isUpcCode?: boolean }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shippingContainerId)) {
      missingRequiredInParams.push('\'shippingContainerId\'');
    }
    if (isNil(inParams.startPackVerificationTaskId)) {
      missingRequiredInParams.push('\'startPackVerificationTaskId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/PackVerification/functions/verify_content_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

